var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileCheckIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-check-03"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M11.6663 2.39063V5.83274C11.6663 6.29945 11.6663 6.53281 11.7572 6.71107C11.8371 6.86787 11.9645 6.99535 12.1213 7.07525C12.2996 7.16608 12.533 7.16608 12.9997 7.16608H16.4418M7.49967 13.8327L9.16634 15.4993L12.9163 11.7493M11.6663 2.16602H7.33301C5.93288 2.16602 5.23281 2.16602 4.69803 2.4385C4.22763 2.67818 3.84517 3.06063 3.60549 3.53104C3.33301 4.06582 3.33301 4.76588 3.33301 6.16602V14.8327C3.33301 16.2328 3.33301 16.9329 3.60549 17.4677C3.84517 17.9381 4.22763 18.3205 4.69803 18.5602C5.23281 18.8327 5.93288 18.8327 7.33301 18.8327H12.6663C14.0665 18.8327 14.7665 18.8327 15.3013 18.5602C15.7717 18.3205 16.1542 17.9381 16.3939 17.4677C16.6663 16.9329 16.6663 16.2328 16.6663 14.8327V7.16602L11.6663 2.16602Z",
    stroke: "#98A2B3",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCheckIcon);
export default __webpack_public_path__ + "static/media/fileCheckIcon.340a03268bacb0136df88277bcfde4b7.svg";
export { ForwardRef as ReactComponent };